import { render, staticRenderFns } from "./Ugly.vue?vue&type=template&id=56dc680d&scoped=true"
import script from "./Ugly.vue?vue&type=script&lang=js"
export * from "./Ugly.vue?vue&type=script&lang=js"
import style0 from "./Ugly.vue?vue&type=style&index=0&id=56dc680d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dc680d",
  null
  
)

export default component.exports